// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JVH-D {\n  height: 100%;\n}\n\n.MO3Ne {\n  margin-top: var(--spacing-md);\n}\n\n._4NTOn {\n  margin-top: var(--spacing-sm);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "JVH-D",
	"actionButton": "MO3Ne",
	"compact": "_4NTOn"
};
export default ___CSS_LOADER_EXPORT___;
